import { useEffect, useRef } from 'react';
import css from './ModalForComments.module.css';
import { BsFillTrashFill } from 'react-icons/bs';

export default function ModalForComments({
  onClose,
  setComment,
  comment,
  checkComment,
  repair,
  commentsList,
  setAddedComments,
  addedComments,
}) {
  const focusRef = useRef(null);

  useEffect(() => {
    if (focusRef && focusRef.current && !comment) {
      focusRef.current.focus();
    }
  });

  const hanleAddComment = e => {
    setComment(e.target.value);
  };

  const handleRemoveItemFromTheList = id => {
    setAddedComments(addedComments?.filter(comment => comment !== id));
  };

  return (
    <div className={css.wrapper}>
      <p className={css.title}>
        {repair && commentsList?.length > 1 ? 'Коментарі' : 'Коментар'}
      </p>
      {repair && checkComment ? (
        <ul className={css.list}>
          {commentsList?.map((item, index) => (
            <li key={index} className={css.listItem}>
              <p className={css.comment}>{item}</p>
              {addedComments && index < addedComments?.length && (
                <BsFillTrashFill
                  className={css.trashIcon}
                  onClick={() => handleRemoveItemFromTheList(item)}
                />
              )}
            </li>
          ))}
        </ul>
      ) : (
        <textarea
          className={css.textarea}
          onChange={hanleAddComment}
          value={comment}
          ref={focusRef}
          disabled={checkComment}
        />
      )}

      <div className={css.btnBox}>
        <button
          type="button"
          className={css.cancel}
          onClick={() => {
            onClose();
            // if (!checkComment) {
            //   setComment('');
            // }
          }}
        >
          Закрити
        </button>
        {!checkComment && (
          <button
            type="button"
            className={css.confirm}
            onClick={() => {
              if (repair) {
                setAddedComments(prev => [comment, ...prev]);
                setComment('');
              }
              onClose();
            }}
          >
            Підтвердити
          </button>
        )}
      </div>
    </div>
  );
}
